import React from 'react';
import { styled } from '@mui/material';

import MemberCard from 'components/organisms/Profile/TeamDetails/MemberCard';
import { useUser2 } from 'contexts/user2';
import { Button, Form, Stack, Text, TextInput } from 'shell/components';

const DesktopTeamDetails = ({ form, errors, onChange, onSubmit }) => {
    const { currentGroupAccountUsers } = useUser2();

    return (
        <CustomStack spacing={4}>
            <Text variant={'sh2'} weight={'semibold'}>
                Team Details
            </Text>
            <Form onSubmit={onSubmit}>
                <Stack sx={{ maxWidth: (theme) => theme.spacing(80) }} spacing={4}>
                    <TextInput
                        error={Boolean(errors.teamName)}
                        helperText={errors.teamName}
                        label={'Team Name'}
                        name={'teamName'}
                        value={form.teamName}
                        onChange={onChange}
                    />
                    <Button sx={{ alignSelf: 'flex-end' }} type={'submit'}>
                        Save
                    </Button>
                </Stack>
            </Form>
            <Text variant={'sh2'} weight={'semibold'}>
                Team Members
            </Text>
            <Stack sx={{ flexWrap: 'wrap' }} direction={'row'} spacing={5}>
                {(currentGroupAccountUsers || []).map((accountUser) => (
                    <MemberCard key={accountUser.owner_account_id} accountUser={accountUser} />
                ))}
            </Stack>
        </CustomStack>
    );
};

const CustomStack = styled(Stack)(({ theme }) => {
    return {
        padding: theme.spacing(5),
    };
});

export default DesktopTeamDetails;
